// extracted by css-extract-rspack-plugin
export default {"MetadataFooterLoadingContainer":"MetadataFooterLoading-module__MetadataFooterLoadingContainer__T44jF"};